export const configPMHExtra = {
  diagnoses: {
    urlOptions: "electronic-medical-record/icd-10-list/",
    proceedOptions: (options) =>
      options.map((i) => ({
        value: i.name,
        code: i.code,
        label: i.name + ` (${i.code})`,
      })),
  },
  medicationsPrescribed: {
    urlOptions: null,
    proceedOptions: (options) =>
      options.map((i) => ({ value: i.name, code: i.code, label: i.name })),
  },
};

export const configPMH = {
  pastMedicalHistory: {
    textAreaData: "",
    fieldDataTextArea: "comment",
    placeholderTextArea: "Additional Information",
    urlOptions: "electronic-medical-record/icd-10-list/",
    textAddButton: "PAST MEDICAL HISTORY",
    proceedOptions: (options) =>
      options.map((i) => ({
        value: i.name,
        code: i.code,
        label: i.name + ` (${i.code})`,
      })),
  },
  familySocialHistory: {
    creatable: true,
    urlOptions:
      "electronic-medical-record/past-medical-history/family-social-history-choices/",
    textAddButton: "FAMILY AND SOCIAL HISTORY",
    proceedOptions: (options) =>
      options.map((i) => ({ value: i.name, code: i.code, label: i.name })),
  },
  medications: {
    urlOptions: null,
    textAreaData: "",
    fieldDataTextArea: "appointedMedications",
    placeholderTextArea: "Medication",
    textAddButton: "MEDICATIONS",
    proceedOptions: (options) =>
      options.map((i) => ({ value: i.name, code: i.code, label: i.name })),
  },
  medicationAllergies: {
    urlOptions: null,
    textAreaData: "",
    fieldDataTextArea: "appointedAllergies",
    placeholderTextArea: "Allergies",
    textAddButton: "ALLERGIES",
    proceedOptions: (options) =>
      options.map((i) => ({ value: i.name, code: i.code, label: i.name })),
  },
};
